export default __webpack_public_path__ + "static/media/Patient T&Cs - SR.b048a3af.pdf";